export var app: MyApp = null;
export const debug: boolean = true;

import { Scroll } from './components/scroll';
import { Menu, MenuState } from './components/menu';
import { Animations } from './components/animations';
import { AjaxHistory } from './components/ajax';

document.addEventListener('DOMContentLoaded', () => {
    debug ? console.log('DOM loaded') : null;
    app = new MyApp();
    app.init();
});

window.addEventListener('load', () => {
    debug ? console.log('Window loaded') : null;
    app.showApp();
});

class MyApp {
    private menu: Menu;
    private animations: Animations;
    private preloader: HTMLElement = document.querySelector('.preloader');
    private ajaxHistory: AjaxHistory;
    public eventDispatcher: EventTarget = new EventTarget();
    public scroll: Scroll;
    public browser: string;
    public mq: string;
    
    constructor() {      
        var self = this;

        this.detectBrowser();
        this.detectMQ();
        this.setSizeVars();

        window.addEventListener('resize', () => {
            this.detectMQ();
            this.setSizeVars();
        });
        
        this.menu = new Menu(
            document.querySelector('.menu-overlay') as HTMLElement,
            document.querySelector('.header-menu-toggle') as HTMLElement
        );
        this.menu.addEventListener('menuStateChange', (event: CustomEvent) => {
            debug ? console.log('Menu state changed', event.detail) : null;
            if (event.detail === MenuState.Open) {
                self.eventDispatcher.dispatchEvent(new CustomEvent('menuOpened', { detail: event.detail}));
            }
            if (event.detail === MenuState.Closed) {
                self.eventDispatcher.dispatchEvent(new CustomEvent('menuClosed', { detail: event.detail}));
                document.querySelectorAll('.menu-overlay-bg')[0].setAttribute('data-selected', '');
            }
        });
        this.menu.addEventListener('mouseenter', (event: CustomEvent) => {
            debug ? console.log('Menu link mouseenter', event.detail) : null;
            const dataIndex = event.detail.getAttribute('data-index');
            if (dataIndex) {
                const selectedIndex = parseInt(dataIndex);
                document.querySelectorAll('.menu-overlay-bg')[0].setAttribute('data-selected', `${selectedIndex}`);
            }
        });
 
        this.scroll = new Scroll();
        this.scroll.handleLiftUp(document.querySelector('.scroll-up') as HTMLElement);

        this.ajaxHistory = new AjaxHistory({ header: ".menu-overlay-items", footer: "footer", content: '#content' }, 500);
        this.ajaxHistory.addEventListener('fetchingPage', (event) => {
            debug ? console.log('Fetching page') : null;
            document.querySelector('html').classList.add('-loading');
        });
        this.ajaxHistory.addEventListener('pageFetched', (event: CustomEvent<{ url: string }>) => {            
            debug ? console.log('Fetching page success') : null;
            self.menu.closeMenu();
            self.menu.reinitialize();
            self.scroll.handleScrollTo(0);
            setTimeout(() => {
                document.querySelector('html').classList.remove('-loading');
            }, 500);
            self.eventDispatcher.dispatchEvent(new CustomEvent('changingPage', { detail: { url: event.detail.url } }));
        });

    }

    private detectBrowser(): void {
        if (navigator.userAgent.indexOf("Chrome") != -1 ) {
            this.browser = "chrome";
        }
        else if (navigator.userAgent.indexOf("Firefox") != -1 ) {
            this.browser = "firefox";
        }
        else if (navigator.userAgent.indexOf("MSIE") != -1 ) {
            this.browser = "msie";
        }
        else if (navigator.userAgent.indexOf("Edge") != -1 ) {
            this.browser = "edge";
        }
        else if (navigator.userAgent.indexOf("Safari") != -1 ) {
            this.browser = "safari";
        }
        else if (navigator.userAgent.indexOf("Opera") != -1 ) {
            this.browser = "opera";
        }
        else if (navigator.userAgent.indexOf("YaBrowser") != -1 ) {
            this.browser = "yabrowser";
        }
        else {
            this.browser = "other";
        }
        document.documentElement.setAttribute('data-browser', this.browser);
    }

    private detectMQ(): void {
        this.mq = '';
        const tailwindConfig = require('../../../tailwind.config.js');
        const mediaQueries = Object.entries(tailwindConfig.theme.screens);

        for (const [key, value] of mediaQueries) {
            if (window.matchMedia(`(min-width: ${value})`).matches) {
                this.mq = key;
            }
        }
        document.documentElement.setAttribute('data-mq', this.mq);
    }

    private setSizeVars(): void {
        const hh: number | null = document.querySelector('.header')?.clientHeight;
        const fh: number | null = document.querySelector('.footer')?.clientHeight;
        
        document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
        hh ? document.documentElement.style.setProperty('--hh', `${hh}px`) : null;
        fh ? document.documentElement.style.setProperty('--fh', `${fh}px`) : null;
    }

    public init(): void {
        this.animations = new Animations();
    }

    public showApp(): void {
        this.preloader.classList.add('-loaded');
    }
}